import { lazy } from 'react';

import type { TAccessoriesChargesRouter } from './types/AccessorialChargesRouter.types';
import type { RouteConfig } from '@/router/route.types';
import type { TPage } from '@/router/type';

import { composeRootPath } from '@/router/utils';

const PAGES: Record<TAccessoriesChargesRouter, TPage> = {
  ACCESSORIAL_CHARGES: {
    id: 'accessorial-charges',
    name: 'Accessorial Charges',
    path: composeRootPath('/accessorial-charges'),
  },
};

const ROUTES: Record<TAccessoriesChargesRouter, RouteConfig> = {
  ACCESSORIAL_CHARGES: {
    id: PAGES.ACCESSORIAL_CHARGES.id,
    name: PAGES.ACCESSORIAL_CHARGES.name,
    path: PAGES.ACCESSORIAL_CHARGES.path,
    component: lazy(() => import('@features/AccessorialCharges/pages/AccessorialCharges.page')),
  },
};

export default {
  PAGES,
  ROUTES,
};
